import { render, staticRenderFns } from "./DissentInfo.vue?vue&type=template&id=8b1b0128&scoped=true&"
import script from "./DissentInfo.vue?vue&type=script&lang=js&"
export * from "./DissentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1b0128",
  null
  
)

export default component.exports